/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Back_To_TopInputs */

const sv_back_to_top = /** @type {(inputs: Back_To_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Till toppen`)
};

const en_back_to_top = /** @type {(inputs: Back_To_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to top`)
};

/**
* | output |
* | --- |
* | "Back to top" |
*
* @param {Back_To_TopInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const back_to_top = /** @type {((inputs?: Back_To_TopInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Back_To_TopInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_back_to_top(inputs)
	return en_back_to_top(inputs)
});